export default __webpack_public_path__ + "static/media/Skecher.63a37c75.jpeg";